import { Reveal } from "@/components/motion/Reveal";
import { CHAPTERS, ASSETS } from "@/lib/site";

export default function Manifesto() {
  return (
    <section id="manifesto" className="relative py-28 md:py-40" data-testid="manifesto">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.28em] font-semibold text-primary mb-6">
            The manifesto
          </p>
          <h2 className="font-serif text-4xl md:text-6xl lg:text-7xl tracking-tight leading-[0.95] max-w-4xl">
            Technology that makes every vote count.
          </h2>
        </Reveal>

        <div className="mt-20 md:mt-28 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12">
          {/* Chapter 01 */}
          <div className="md:col-span-7">
            <ChapterBlock c={CHAPTERS[0]} />
          </div>
          <div className="md:col-span-5 md:pt-16">
            <Reveal delay={0.1}>
              <div className="relative overflow-hidden rounded-lg border border-border">
                <img
                  src={ASSETS.community}
                  alt="Indigenous community hands joined"
                  className="w-full h-[360px] md:h-[420px] object-cover transition-transform duration-[1.2s] hover:scale-105"
                />
                <div className="absolute inset-0 bg-secondary/20 mix-blend-multiply" />
              </div>
            </Reveal>
          </div>

          {/* Chapter 02 */}
          <div className="md:col-span-5 md:col-start-2 md:pt-10">
            <ChapterBlock c={CHAPTERS[1]} />
          </div>
          <div className="md:col-span-5 md:col-start-8 flex items-end">
            <Reveal delay={0.1} className="w-full">
              <div className="border-l-2 border-primary pl-6 md:pl-8">
                <p className="font-serif text-2xl md:text-3xl leading-snug text-foreground/85">
                  “A proposal that once took a month of meetings now takes an
                  afternoon — and it still sounds like us.”
                </p>
              </div>
            </Reveal>
          </div>

          {/* Chapter 03 */}
          <div className="md:col-span-8 md:col-start-4">
            <ChapterBlock c={CHAPTERS[2]} />
          </div>
        </div>
      </div>
    </section>
  );
}

function ChapterBlock({ c }) {
  return (
    <Reveal>
      <div className="flex gap-6 md:gap-8">
        <span className="font-serif text-6xl md:text-8xl leading-none text-gradient shrink-0">
          {c.no}
        </span>
        <div className="pt-2 md:pt-4">
          <h3 className="font-serif text-2xl md:text-4xl tracking-tight mb-4">{c.title}</h3>
          <p className="text-base md:text-lg text-foreground/70 leading-relaxed max-w-xl">
            {c.body}
          </p>
        </div>
      </div>
    </Reveal>
  );
}
